<template>
	<div class="body">
		<el-card class="box-card">
			<el-row class="title">
				<span class="titl">展具及绿植租赁</span>
				<span class="date">申请截止时间：2023年10月20日</span>
			</el-row>

			<el-tabs v-model="tabActive" @tab-click="handleClick">
				<el-tab-pane label="展具租赁" name="exhibition">
					<!-- 说明面板开始 -->
					<el-collapse v-model="foldingNames" @change="handleChange">
						<el-collapse-item name="1" class="collapse">
							<!-- 折叠头部 -->
							<template slot="title">
								<span class="instructions">说明:</span>
								<span class="txt"
									>本届展会的家具和绿植租赁由北京中展商务服务有限公司提供，详细服务信息请参考下图</span
								>
								<span class="folding">{{ folding }}</span>
							</template>
							<!-- 折叠体 -->
							<div class="box">
								<div class="left">
									<img src="../../../../static/indexBanner.png" alt="" />
								</div>
								<div class="right">
									<div class="font" v-for="(item, index) in message" :key="index">
										<p class="title">{{ item.title }}</p>
										<p class="txt" v-for="(i, k) in item.text">{{ i }}</p>
									</div>
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>
					<!-- 说明面板结束 -->
				    	<Furniture></Furniture>
		

				</el-tab-pane>

				<!-- 绿植部分开始 -->
				<el-tab-pane label="绿植租赁" name="greenPlant">
					<!-- 说明面板开始 -->
					<el-collapse v-model="foldingNames" @change="handleChange">
						<el-collapse-item name="1" class="collapse">
							<!-- 折叠头部 -->
							<template slot="title">
								<span class="instructions">说明:</span>
								<span class="txt"
									>本届展会的家具和绿植租赁由北京中展商务服务有限公司提供，详细服务信息请参考下图</span
								>
								<span class="folding">{{ folding }}</span>
							</template>
							<!-- 折叠体 -->
							<div class="box">
								<div class="left">
									<img src="../../../../static/indexBanner.png" alt="" />
								</div>
								<div class="right">
									<div class="font" v-for="(item, index) in message" :key="index">
										<p class="title">{{ item.title }}</p>
										<p class="txt" v-for="(i, k) in item.text">{{ i }}</p>
									</div>
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>
				  	<!-- 说明面板结束 -->
					<GreenFurniture></GreenFurniture>
			
				</el-tab-pane>
				<!-- 绿植部分结束 -->
			</el-tabs>
		</el-card>
	</div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

import Furniture from './planComponent/furniture.vue'; //说明部分
import GreenFurniture from './planComponent/greenFurniture.vue'; //说明部分

export default {
	components: {
		swiper,
		swiperSlide,
		Furniture, //家具部分
		GreenFurniture,
	
	},
	data() {
		return {
			tabActive: 'exhibition', //默认展开项为家具租赁
			foldingNames: ['1'], //折叠面板说明
			//说明中的折叠信息
			message: [
				{
					title: '服务电话',
					text: [
						'展期现场服务点电话',
						'W馆 010-80468229、E馆 010-80468230',
						'手机 13691586795、13811600271、13552931289',
						'服务监督电话 010-80468237 / 80468249',
						'邮箱 sfcs@ciec.com.cn',
					],
				},
				{
					title: '服务时间',
					text: ['布展期 9:00-17:00', '布展最后一天 9:00-21:00', '开展期 9:00-17:00'],
				},
				{
					title: '服务地点',
					text: [
						'W1-W2 / E1-E2卸货区租赁办公点',
						'W3-W4 / E3-E4卸货区临增办公点',
						'临增租赁服务点视展会大小开放',
						'免费配送、维护、回收、发票开具',
					],
				},
			],
			folding: '收起', //说明下的折叠面板切换
			dialogVisible: true,
		};
	},
	methods: {
		//展具or绿植切换
		handleClick(tab, event) {
			console.log(tab, event);
		},
		//说明下的折叠面板切换函数
		handleChange(val) {
			console.log('555');
			val.length == 1 ? (this.folding = '收起') : (this.folding = '展开');
		},
	},
};
</script>
<style scoped lang="scss">
.body {
	margin: 17px 26px 0px 26px;
	background-color: #f0f2f5;
	position: relative;
	.box-card {
		.title {
			font-size: 20px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
			line-height: 28px;
		}
		.date {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			line-height: 20px;
			margin-left: 20px;
		}
		.collapse {
			.instructions {
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #ff190c;
				line-height: 22px;
				margin-left: 30px;
			}
			.txt {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 22px;
			}
			.folding {
				position: absolute;
				top: 0px;
				right: 35px;
			}
			.box {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-top: 20px;
				padding-left: 72px;
				box-sizing: border-box;
				background: #f6f6f7;
				.left {
					width: 549px;
					height: 476px;
					img {
						width: 549px;
						height: 476px;
					}
				}
				.right {
					flex: 1;
					height: 100%;
					height: 476px;

					padding-left: 30px;
					box-sizing: border-box;
					.font {
						.title {
							font-size: 16px;
							font-family: PingFangSC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							line-height: 22px;
							margin-top: 10px;
						}
						.txt {
							font-size: 14px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							line-height: 20px;
							margin-top: 10px;
						}
					}
				}
			}
		}
	}
}
</style>
<style scoped>
.collapse >>> .el-collapse-item__header {
	background-color: #f6f6f7;
}
.collapse >>> .el-collapse-item__wrap {
	background-color: #f6f6f7;
}
.collapse >>> .el-collapse-item__header {
	position: relative;
}

.el-input-number {
	width: 91px;
	height: 24px;
	line-height: 24px;
}
.el-input-number >>> .el-input__inner {
	line-height: 24px !important;
	height: 24px !important;
	padding: 0px;
	border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
	width: 24px !important;
	height: 22px !important;
}

.el-dialog__wrapper >>> .el-dialog__header {
	padding: 15px 20px 10px;
	background: #006fb8;
}
.el-dialog__wrapper >>> .el-dialog__title {
	font-size: 16px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__close {
	color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__body {
	padding: 20px 20px 0px 20px;
}
</style>
